import { PageSixty, PageAlwaysVisible, PageTitle, ThemeContext, logo, Section_Title, Main_Loader, PageSubtitle, Partial_Loader, P, Main_, Grey_Link, AlertContext, Confirmation_} from 'monica-alexandria';
import React, {useContext, useEffect, useState } from "react";
import { prettifyDates } from "../../../helpers/prettifiers";
import store from "../../../redux/store";
import { useLocation, useNavigate } from "react-router-dom";
import { getTransactions, getInvoicesByQuestId, getStripeTransactionsCRM } from "../../../services/api/Transactions";
import { create_portal_session, get_my_subscriptions } from "../../../services/api/Mocks";
import i18n from "../../../localization/i18next";
import { useTranslation } from "react-i18next";
import { prettifyPrice } from "../../../helpers/prettifyFunctions";
import currencies from '../../../data/currencies.json';
import { Helmet } from "react-helmet";
import Subscription_Plan from "../../../components/subscription/Subscription_Plan";
import Subscription_History_Block from "../../../components/subscription/Subscription_History_Block";
import styled from 'styled-components';
import { getQuestsWithSubIds } from '../../../services/api/Quests';
import { cancelSubscription, get_crm_subscriptions, renewSubscription } from '../../../services/api/Subscriptions';

const DailyprofitPlan = styled.div`
`;

const DailyprofitQuestWrapper = styled.div`
`;
export default function CRM_PLAN() {

    const protocol = process.env.REACT_APP_DAILYPROFIT_FRONTEND_PROTOCOL;
    const url = process.env.REACT_APP_DAILYPROFIT_FRONTEND_HOST;
    const port = process.env.REACT_APP_DAILYPROFIT_FRONTEND_PORT;
    const dailyprofitURL = `${protocol}${url}${port}`;

    const g_protocol = process.env.REACT_APP_GRIPHOOK_FRONTEND_PROTOCOL;
    const g_url = process.env.REACT_APP_GRIPHOOK_FRONTEND_HOST;
    const g_port = process.env.REACT_APP_GRIPHOOK_FRONTEND_PORT;
    const griphookFrontURL = `${g_protocol}${g_url}${g_port}`;

    const user = store.getState().user.user;
    const userId = user.sub;
    const { t } = useTranslation();
    const location = useLocation();
    const { theme } = useContext(ThemeContext);
    const navigate = useNavigate();

    const lang = i18n.language ? i18n.language : 'en';
    const [isLoading, setIsLoading] = useState(false);
    const { alerts, setAlerts } = useContext(AlertContext);

    const redirectURL = `${window.location.origin}${window.location.pathname}?name=Adsnap&category=lois`;
    const paymentURL = `${griphookFrontURL}/${lang}/checkout-crm`
    const [ initialLoading, setInitialLoading ] = useState(true);

    const [activeSubs, setActiveSubs] = useState([]);
    const [inactiveSubs, setInactiveSubs] = useState([]);
    const [activeSub, setActiveSub] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [wrappInvoices, setWrappInvoices] = useState([]);
    const [cancelConfirm, setCancelConfirm] = useState(false);
    const [renewConfirm, setRenewConfirm] = useState(false);

    const [loadingInvoices, setLoadingInvoices] = useState(false);
    
    const go_to_edit_subscription = (customer) => {
  
      let payload = {
        customer,
        lang:lang,
        userId,
        redirectURL
      }
  
      create_portal_session(payload)
        .then(data => {
          if (data?.data?.url) {
            setIsLoading(false)
            window.location.assign(data?.data?.url)
          }
          else isLoading(true);
        })
        .catch(err => {})
    }

    const fetchMySubs = (attempt = 0) => {
      get_crm_subscriptions(userId)
      .then(res => {
        console.log('dataaaaaaaaaaaaaaaaaaa', res);
        const mySubs = res
        setActiveSubs(mySubs?.filter((quest) => quest?.status == 'active'));
        setInactiveSubs(mySubs?.filter((quest) => quest?.status !== 'active'));

        // Stripe's successful-payment webhook can reach Erised just after the
        // checkout redirects here. Retry briefly so a newly paid CRM plan is
        // not rendered as an empty page.
        if (!mySubs?.length && attempt < 4) {
          setTimeout(() => fetchMySubs(attempt + 1), 1000);
          return;
        }

        setInitialLoading(false);

      })
      .catch(err => {
        if (attempt < 4) {
          setTimeout(() => fetchMySubs(attempt + 1), 1000);
          return;
        }
        setInitialLoading(false);
      });
    }

     const cancel_subscription = () => {
      
        cancelSubscription(activeSub?.subscription)
        .then(res => {
          console.log(res);
          if(res.data.code === "CSS2000") {
            setActiveSub((prevState) => ({
              ...prevState,
              cancel_at_period_end: true  
            }));
            const message = (t("Your plan was canceled"));
            const status = "Success";
            alertMessage(message, status);
          }
        })
        .catch(err => console.log(err))
    }

    const renew_subscription = () => {

      renewSubscription(activeSub?.subscription)
      .then(res => {
        console.log(res);
        if(res.data.code === "UCS2000") {
          setActiveSub((prevState) => ({
            ...prevState, 
            cancel_at_period_end: false  
          }));
          const message = (t("Your plan renewed"));
          const status = "Success";
          alertMessage(message, status);
        }    
      })
      .catch(err => console.log(err))
    }

    const alertMessage = (message, status) => {
      setAlerts([
        ...alerts,
        {
          message: {
            text: t(message),
            status: status,
          },
        },
      ]);
      setTimeout(() => {
        setAlerts([]);
      }, 8000);
    };

    useEffect(() => {
      fetchMySubs();
    }, []);

    useEffect(() => {
      // Init activeSub in order to init invoices
      if(activeSubs?.length > 0) {
        setActiveSub(activeSubs[0])
      }
      else if(inactiveSubs?.length > 0) {
        setActiveSub(inactiveSubs[0])
      }
    }, [activeSubs, inactiveSubs]);

    useEffect(() => {
      if(activeSub) {
        console.log('getting invoiced for: ', activeSub);
        setInvoices([]);
        setLoadingInvoices(true);
        getStripeTransactionsCRM(activeSub?.customer, activeSub?.subscription)
        .then((res) => { 
          console.log("res data",res);
          setInvoices(res?.data);
          setWrappInvoices(res?.wrappInvoices);
          setLoadingInvoices(false);
        })
        .catch((error) => console.log(error))
      }

    }, [activeSub]);
  
      console.log('activeSubs: ', activeSubs);
      console.log('inactiveSubs: ', inactiveSubs);
      console.log('activeSub: ', activeSub);
      console.log('invoices: ', invoices);

  const does_invoice_have_a_wrapp_id = (invId) => {

    let found = false;

    console.log('wrappInvoices invId', wrappInvoices, invId)
    
    found = invoices?.findIndex(item => item?.id == invId && item?.wrappId);

    if (found > -1) {
      return invoices[found]?.wrappId;
    }
    else {
      console.log('wrappInvoices invId', wrappInvoices, invId)
      found = wrappInvoices?.findIndex(item => item?.invoiceId == invId && item?.wrappId)
    }

    if (found > -1) {
      console.error("AAAAAAAAAAAAAAA", found, wrappInvoices)
      return wrappInvoices[found]?.wrappId;
    }
    else {
      return false;
    }
  }

  const navigate_to_pdf = (invId) => {

    const invoiceId = does_invoice_have_a_wrapp_id(invId);

    console.log(`https://wrapp.ai/${lang}/customer_portal/${invoiceId}`)

    const width = window?.screen?.availWidth || '1400';
    const height = window?.screen?.availHeight || '900';
    
    const features = [
      `width=${width}`,
      `height=${height}`,
      'left=0',
      'top=0',
      'fullscreen=yes', // Try this first
      'scrollbars=yes',
      'toolbar=no',
      'menubar=no',
      'location=no',
      'status=no',
      'resizable=yes'
    ].join(',');

    window.open(
      `https://wrapp.ai/${lang}/customer_portal/${invoiceId}`, '_blank', features
    );
  }
      
      
  return (
    <DailyprofitPlan>
        <Helmet>
          <title>{`Doitforme | CRM subscription`}</title>
        </Helmet>

        { initialLoading ? <Main_Loader /> : 
        <PageSixty>
            <PageAlwaysVisible>
              <PageTitle>
                <Grey_Link noPadding iconLeft="Back" onClick={() => navigate(-1)} />
                <h1>{"CRM"} {t("subscription")}</h1>
              </PageTitle>
              {activeSubs?.length > 0 && 
              <DailyprofitQuestWrapper>
                <Section_Title text={t("Active CRM subscriptions")}/>
                {cancelConfirm && (
                  <Confirmation_
                    message={t("Are you sure you want to cancel your subscription?")}
                    yes={t("Yes")}
                    onYes={() => {cancel_subscription(); setCancelConfirm(false)}}
                    onNo={() => setCancelConfirm(false)}
                    no={t("No")}
                  />
                )}
                {renewConfirm && (
                  <Confirmation_
                  message={t("Are you sure you want to renew your subscription?")}
                  yes={t("Yes")}
                    onYes={() => {renew_subscription(); setRenewConfirm(false)}}
                    onNo={() => setRenewConfirm(false)}
                    no={t("No")}
                  />
                )}
                {activeSubs?.map((quest) => {
                  let daysLeft = Math.ceil((quest?.current_period_end * 1000 - Date.now()) / (1000 * 60 * 60 * 24));
                  return (
                    <Subscription_Plan 
                      title={t("CRM")}
                      category="crm"
                      img={logo["bond"][theme]}
                      currency= {currencies[quest?.currency?.toUpperCase()]?.symbol || currencies["EUR"]?.symbol}
                      onEditCard={()=> { go_to_edit_subscription( activeSub?.customer) } }
                      onRestartSub={() => window.location.assign(paymentURL)}
                      price={prettifyPrice(quest?.amount)}
                      daysLeft={daysLeft}
                      nextPayment={prettifyDates(quest?.current_period_end, true, lang)}
                      onClick={() => setActiveSub(quest)}
                      questId={quest?._id}
                      taxBehavior="inclusive"
                      isActive={quest?.active}
                      newBudget={false}
                      onCancel={()=> setCancelConfirm(true)}
                      onRenew={()=> setRenewConfirm(true)}
                    />
                  )
                })}
              </DailyprofitQuestWrapper>}
              {inactiveSubs?.length > 0 && 
              <DailyprofitQuestWrapper>
                <Section_Title text={t("Archived CRM subscriptions")}/>
                {inactiveSubs?.map((quest) => {
                  let daysLeft = Math.ceil((quest?.current_period_end * 1000 - Date.now()) / (1000 * 60 * 60 * 24));

                  return (
                    <Subscription_Plan 
                      title={t("CRM")}
                      category="crm"
                      img={logo["bond"][theme]}
                      currency= {currencies[quest?.currency?.toUpperCase()]?.symbol || currencies["EUR"]?.symbol}
                      price={prettifyPrice(quest?.amount)}
                      daysLeft={daysLeft}
                      onClick={() => setActiveSub(quest)}
                      taxBehavior="inclusive"
                      isActive={quest?.active}
                    />
                  )
                })}
              </DailyprofitQuestWrapper>}
            </PageAlwaysVisible>
            <PageAlwaysVisible>
              <Section_Title text={t('Payment History')} />
                {loadingInvoices ? <Partial_Loader /> : null}
                {invoices?.length > 0 && activeSub &&
                  invoices?.map((invoice, i) => {
                    return (
                      <Subscription_History_Block
                        key={i}
                        currency={currencies[invoice?.currency.toUpperCase()]?.symbol}
                        price={prettifyPrice(invoice?.total)}
                        status={invoice?.status}
                        date={prettifyDates(invoice?.created, true)}
                        invoicePdf={does_invoice_have_a_wrapp_id(invoice?.id)}
                        invoice={does_invoice_have_a_wrapp_id(invoice?.id)}
                       onInvoice={()=> navigate_to_pdf(invoice?.id)}
                      />
                    );
                  })}
  
            </PageAlwaysVisible>

            
        </PageSixty> }
    </DailyprofitPlan>
  )
}
